var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$root.user.active
      ? _c(
          "div",
          [
            _vm._v("\n        " + _vm._s(_vm.status) + "\n        "),
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm._l(_vm.invoices, function(item, index) {
              return _c(
                "div",
                { staticClass: "row setting finance row-list-item" },
                [
                  _c("div", { staticClass: "col col-70" }, [
                    _c("div", { staticClass: "account-info__title" }, [
                      _vm._v(_vm._s(item.updateDate))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "account-info__subtitle" }, [
                      _c("p", [_vm._v("Factuurnummer: " + _vm._s(item.number))])
                    ]),
                    _vm._v(" "),
                    item.prepaid == true
                      ? _c("div", { staticClass: "account-info__subtitle" }, [
                          _c("p", [
                            _vm._v(_vm._s(item.priceVat) + " incl. BTW")
                          ])
                        ])
                      : _c("div", { staticClass: "account-info__subtitle" }, [
                          _c("p", [
                            _vm._v(_vm._s(item.price) + " excl. BTW "),
                            _c("br"),
                            _c("span", { staticClass: "account-info__vat" }, [
                              _vm._v(_vm._s(item.priceVat) + " incl. BTW")
                            ])
                          ])
                        ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col col-30" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col col-50",
                          on: {
                            click: function($event) {
                              return _vm.export_data(
                                "Factuur " + item.number,
                                item.id
                              )
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/send-invoice.svg")
                            }
                          })
                        ]
                      )
                    ])
                  ])
                ]
              )
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row setting row-last explanation" }, [
      _c("div", [
        _vm._v(
          "\n                Dit is het overzicht van al jouw facturen. Vanuit dit scherm kun je een factuur versturen naar je emailadres.\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Facturen")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e9b3fd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e9b3fd4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Invoices.vue
// module id = null
// module chunks = 